class TagManager {
  /**
   * Add an event to the tag manager data layer
   * @param {string} event
   * @param {string} eventAction
   * @param {string} eventLabel
   * @param {object} other
   */
  addEvent (eventCategory, eventAction, eventLabel, other = {}) {
    if (process.env.VUE_APP_ANALYTICS === 'true') {
      window.dataLayer = window.dataLayer || []
      const dataLayerObject = Object.assign(
        {
          event: 'interactionEvent',
          eventCategory,
          eventAction,
          eventLabel,
        }, other)

      window.dataLayer.push(dataLayerObject)
    }
  }
}

export default new TagManager()
